import { render, staticRenderFns } from "./InventionMemberSave.vue?vue&type=template&id=6417b6aa&"
import script from "./InventionMemberSave.vue?vue&type=script&lang=js&"
export * from "./InventionMemberSave.vue?vue&type=script&lang=js&"
import style0 from "./InventionMemberSave.vue?vue&type=style&index=0&id=6417b6aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports